import React from 'react';
import { QrCode, Barcode, Tags } from 'lucide-react';
import { useLang } from '../i18n';

// Visible, crawlable internal links from the homepage to the most important
// generator landing pages. Helps users navigate and lets search engines
// discover the key pages faster.
export const PopularGenerators = ({ className = 'mt-12' }) => {
  const { t, lang } = useLang();
  const base = lang === 'en' ? '/en' : '';
  const items = [
    ['qr-code-generator', 'QR-Code', QrCode],
    ['barcode-generator', 'Barcode', Barcode],
    ['ean-13-generator', 'EAN-13', Barcode],
    ['ean-8-generator', 'EAN-8', Barcode],
    ['upc-generator', 'UPC-A', Barcode],
    ['code-128-generator', 'Code 128', Barcode],
    ['code-39-generator', 'Code 39', Barcode],
    ['isbn-barcode-generator', 'ISBN', Barcode],
    ['gs1-barcode-generator', 'GS1-128', Barcode],
    ['barcode-labels', lang === 'en' ? 'Labels (A4)' : 'Etiketten (A4)', Tags],
  ];
  return (
    <section className={className} data-testid="popular-generators" aria-labelledby="popgen-heading">
      <div className="mb-4 text-center">
        <h2 id="popgen-heading" className="font-heading text-xl font-semibold text-foreground sm:text-2xl">
          {t('popular_generators')}
        </h2>
        <p className="mx-auto mt-1 max-w-lg text-sm text-muted-foreground">
          {t('popular_generators_sub')}
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {items.map(([slug, label, Icon]) => (
          <a
            key={slug}
            href={`${base}/${slug}/`}
            data-testid={`home-gen-${slug}`}
            className="group flex items-center gap-2.5 rounded-xl border bg-card px-4 py-3 text-sm font-medium text-foreground transition-colors hover:border-primary hover:bg-secondary/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <Icon className="h-4 w-4 shrink-0 text-primary transition-transform group-hover:scale-110" />
            <span>{label}</span>
          </a>
        ))}
      </div>
    </section>
  );
};
